import React from 'react'
const MobileDashboard = () => {
  return (
    <div>
      Mobile Dashboard
    </div>
  )
}

export default MobileDashboard
